import React, { useEffect, useState } from "react";
import FilterableTabCard from "../../../components/tabs/FilterableTabCard";
import Layout from "../../../components/layout/Layout";
import { Box } from "@mui/material";
import CommonNavigator from "../../../components/common/CommonNavigator";
import CustomDrawer from "../../../components/layout/CustomDrawer";
import { BusinessTrends } from "./BusinessTrend";
import ServiceTouchPoints from "./ServiceTouchPoints";
import ClientVotesSpread from "./ClientVotesSpread";
import ActivityTrend from "./ActivityTrend";
import CAccessSummary from "./CAccessSummary";
import CAccessActivities from "./CAccessActivites";
import FilterPanel from "../../../components/filters/FilterPanel";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useGetClientDetailQuery } from "../../../redux/service/modules/sales";
import { useGetAnalystListQuery } from "../../../redux/service/modules/dashboard";
import { useGetUsersQuery } from "../../../redux/service/modules/admin";
import { ClientCard } from "./ClientCard";

export const ClientPerformance = () => {
    const [isFilterOpen, toggleFilter] = useState(false);
    const [activeTab, setActiveTab] = useState(0);

    const dateRange = useSelector((state) => state.date);
    const [filters, setFilters] = useState([]);
    const [requiredFilters, setRequiredFilters] = useState([]);
    const { id } = useParams();

    const [filterDetails, setFilterDetails] = useState({
        appliedFilters: {
            client_id: id,
            start_date: dateRange?.startDate,
            end_date: dateRange?.endDate,
        },
    });
    const { data: clientDetail } = useGetClientDetailQuery({
        client_id: id,
        start_date: dateRange?.startDate,
        end_date: dateRange?.endDate,
    });
    const { data: analystList } = useGetAnalystListQuery();
    const { data: userList } = useGetUsersQuery({
        appliedFilters: { full_list: true },
    });

    // const userList = []

    useEffect(() => {
        const availableFiltersMap = {
            analyst: {
                name: "analystName",
                label: "Analyst Name",
                key: "analyst",
                options:
                    analystList?.map((analyst) => ({
                        label: analyst.username,
                        id: analyst.id,
                    })) || [],
                multiSelect: true,
            },
            user: {
                name: "userName",
                label: "Users Name",
                key: "user",
                options:
                    userList?.map((user) => ({
                        label: user.username,
                        id: user.id,
                    })) || [],
                multiSelect: true,
            },
        };

        const activeFilters = requiredFilters
            .map((filterKey) => availableFiltersMap[filterKey])
            .filter(Boolean);

        setFilters(activeFilters);
    }, [requiredFilters, analystList]);

    useEffect(() => {
        setFilterDetails({
            appliedFilters: {
                ...filterDetails.appliedFilters,
                client_id: id,
            },
        });
    }, [dateRange, id]);

    const tabs = [
        {
            label: "Business Trends",
            content: BusinessTrends,
            showFilter: false,
            showDateRange: false,
        },
        {
            label: "Service Touchpoints",
            content: ServiceTouchPoints,
            showFilter: true,
            showDateRange: false,
        },
        {
            label: "Activity Trends",
            content: ActivityTrend,
            showFilter: false,
            showDateRange: false,
        },
        {
            label: "Votes Spread",
            content: ClientVotesSpread,
            showFilter: true,
            showDateRange: false,
        },
        {
            label: "C-Access Summary",
            content: CAccessSummary,
            showFilter: true,
            showDateRange: false,
        },
        {
            label: "C-Access Activities",
            content: CAccessActivities,
            showFilter: true,
            showDateRange: false,
        },
    ];

    const onFilterApply = (filtersVal, filterCount, rawFilters) => {
        toggleFilter(false);
        setFilterDetails({
            appliedFilters: { ...filtersVal, client_id: id },
            filterCount,
            rawFilters,
        });
    };

    const handleTabChange = (newValue) => {
        setActiveTab(newValue);
        setFilterDetails({
            appliedFilters: {
                client_id: id,
            },
            filterCount: 0,
            rawFilters: {},
        });
    };

    return (
        <Layout>
            <Box className="px-1">
                <div className="mb-2">
                    <CommonNavigator
                        title={"Client Performance"}
                        showBackButton
                        startDate={dateRange?.startDate}
                        endDate={dateRange?.endDate}
                    />
                </div>

                <div className="mb-2">
                    <ClientCard data={clientDetail} />
                </div>

                <FilterableTabCard
                    tabs={tabs}
                    onTabClick={handleTabChange}
                    onFilterClick={() => toggleFilter(true)}
                    appliedFilters={filterDetails.appliedFilters}
                    filterCount={filterDetails.filterCount}
                    isShowFilter={false}
                    setRequiredFilters={setRequiredFilters}
                    value={activeTab}
                />
                <CustomDrawer open={isFilterOpen}>
                    <FilterPanel
                        filtersContent={filters}
                        handlePanelClose={() => toggleFilter(false)}
                        onApply={onFilterApply}
                        appliedFilters={filterDetails.rawFilters}
                    />
                </CustomDrawer>
            </Box>
        </Layout>
    );
};
